
if (
  !document.getElementById("ProductJson") ||
  window.location.pathname.startsWith("/account") ||
  window.location.pathname.startsWith("/login")
) {
  console.log("AgChimp JS skipped");
} else {
var isWholesale = false;
var productJson = '';
var agcProductData = '';
var productVariants='';
var productType='';
var tags = '';
var isLoaded=false;
console.log('isLoaded',isLoaded)
var productNutrientHandles=[];
var grassTypeHandles=[];
var cropTypeHandles=[];
var repllentControls=[];

var metaNutrientHandles=[];
var metaGardenCrops = [];
var metaLawnGrasses=[];
var metaWeeds=[];
var metaInsects=[];
var metaDiseases=[];
var hasMapMetafield=false;

let isPesticide = false;
let isHerbicide = false;
let isFungicide = false;
let isInsecticide = false;
let isRepellents = false;
let isFertilizer=false;
let controlsType = '';
let isMapAcknowledged=false;
async function getProduct(){
 const product = JSON.parse(
    document.getElementById("ProductJson").textContent
  );
agcProductData = product;
let tokenData = null;

try {
  tokenData = JSON.parse(localStorage.getItem("agchimpToken"));
} catch (e) {
  console.warn("Invalid agchimpToken");
}
console.log(window.customerData)
var xcustomerData = window.customerData;
console.log(xcustomerData)
if(xcustomerData !== null){
isWholesale =
  Array.isArray(xcustomerData.tags) &&
  xcustomerData.tags.includes("wholesale");
  const hasMapMetafield =
  xcustomerData.metafields &&
  xcustomerData.metafields.hasOwnProperty("ismapacknowledged");

const isMapAcknowledged =
  xcustomerData.metafields?.ismapacknowledged === true;

}

if (isWholesale && hasMapMetafield && !isMapAcknowledged) {
  console.log("MAP acknowledgment REQUIRED");
  $('.agc-map-acknowledgement').removeClass('d-none');
  $('#agcAddToCart').prop('disabled',true)
  // 👉 disable ATC, show checkbox, redirect, etc.
}
var settings = {
  "url": "https://agchimpapi.azurewebsites.net/api/Shopify/graph",
  "method": "POST",
  "timeout": 0,
  "headers": {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + tokenData.token,
  },
  "data": JSON.stringify({
    query: `query GetProductById($id: ID!) {
  product(id: $id) {
    id
    handle
    title
    productType
    tags

    # 🔹 PRODUCT METAFIELDS
    metafields(first: 50) {
      edges {
        node {
          id
          namespace
          key
          type
          value
        }
      }
    }

    # 🔹 VARIANT METAFIELDS
    variants(first: 100) {
      edges {
        node {
          id
          title
          sku

          metafields(first: 50) {
            edges {
              node {
                id
                namespace
                key
                type
                value
              }
            }
          }
        }
      }
    }
  }
}
`,
    variables: {"id":"gid://shopify/Product/" + agcProductData.id}
  })
};

const response = await $.ajax(settings)

  productJson=response;
  var productData = response.data.product;

  productVariants = response.data.product.variants.edges;

  productType = productData.productType;
  if(productType=='garden fertilizer'){
    $('.agc-crop-nutrients-title').removeClass('d-none');
  }
  tags = productData.tags;
  if(productData.hasOwnProperty('metafields')){
  // Nutrient Metafields
   var re = productData.metafields.edges;
     // Nutrient Metafields
   $.each(re,function(){
    if(this.node.key === "nutrient_content"){
      productNutrientHandles=this.node.value;
     
    }
      // Grass Types Metafields
    if(this.node.key === "agc_all_grass_types"){
      grassTypeHandles=this.node.value;
    }
    //Get all use crops
    if(this.node.key === "agc_garden_crop_types"){
      cropTypeHandles=this.node.value;
    }
    
  })
  //Show Nutrient Contents Div
  
  if(productType==="Lawn Fertilizer" || productType==="Pre-Emergent Herbicides" || productType == "Lawn Fungicide"){

    await handleListObjects('nutrients',metaNutrientHandles,'list',productNutrientHandles,metaNutrientHandles,'nutrients');
    await handleListObjects('lawn_grasses',metaLawnGrasses,'list',grassTypeHandles,metaLawnGrasses,'grasses');
    $('.nutrients').removeClass('d-none');
  }
  if(productType==="Garden Fertilizer" || productType == "garden fertilizer"){
 console.log('crops')
  
     await handleListObjects('cropNutrients',metaNutrientHandles,'list',productNutrientHandles,metaNutrientHandles,'cropNutrients');
    await handleListObjects('garden_crops',metaGardenCrops,'list',cropTypeHandles,metaGardenCrops,'crops');
    $('.garden_feed_instructions').removeClass('d-none');
  }
  
  //Show Repellents Div
  if (tags.includes('Repellents') || tags.includes('repellents')) {
    $('.repellents').removeClass('d-none');
    isRepellents = true;


  }
     if (tags.includes('pesticide')) {
    isPesticide=true;
    $('.controls').removeClass('d-none');
    if(tags.includes('herbicide') || tags.includes('Herbicide')){
      $('#controlledTag').html('Weeds');
      await handleListObjects('weed',metaWeeds,'pest');

    }
     if(tags.includes('insecticide') || tags.includes('Insecticide')){
      $('#controlledTag').html('Insects');
        await handleListObjects('insects',metaInsects,'pest');

    }
     if(tags.includes('fungicide') || tags.includes('Fungicide')){
      $('#controlledTag').html('Diseases');
        await handleListObjects('diseases',metaDiseases,'pest');
 
    }
    
  }
  }
  fireVariantButtons();
  activateFirstVisibleTab();
if (!window.customerData?.tags?.includes('wholesale')) {
  await loadComplementaryProduct(productJson);
}
}
function activateFirstVisibleTab() {
  // Remove any existing active states
  document.querySelectorAll('.agc-tab.active').forEach(el => el.classList.remove('active'));
  document.querySelectorAll('.agc-tab-content.active').forEach(el => el.classList.remove('active'));

  // Find first visible tab (not d-none)
  const firstTab = document.querySelector('.agc-tab:not(.d-none)');
  if (!firstTab) return;

  // Activate tab
  firstTab.classList.add('active');

  // Activate matching tab content
  const tabId = firstTab.getAttribute('data-tab');
  if (!tabId) return;

  const content = document.getElementById(tabId);
  if (content) {
    content.classList.add('active');
  }
}
async function handleListObjects(type,targetArray,callType,listHandles,compareTo,source) {
console.log(type,targetArray,callType,listHandles,compareTo,source)
var variableArray=listHandles;
  if (!Array.isArray(targetArray)) {
    console.error('handleListObjects: targetArray must be an array');
    return;
  }
    try {
      const response = await graphQLMetaObjectsControlsCall(type);
      console.log(response)
      if(callType=='list'){
      //if retrieving list of metaobject values
        
        $.each(response.data.metaobjects.edges,function(){
        targetArray.push({
        'handle': this.node.handle,
        'fields': this.node.fields
        })
          })
          
         explodeMetaObjects(variableArray,compareTo,source);
      
    }
    if(callType=='pest'){
      //if retrieving list of metaobject values for a specific control (weeds,insects,diseases)
        $.each(response.data.metaobjects.edges,function(){
        var selectedWeed = this;
        $.each(this.node.fields,function(){
      
        if (this.key === "products" && this.references?.edges) {
        $.each(this.references.edges, function(index, edge) {
        if(edge.node.id==="gid://shopify/Product/" + agcProductData.id){
        targetArray.push(selectedWeed);
        }
        });
        }
        })
        })
        renderControlsInTab(targetArray);
    }
    } catch (err) {
      console.error("GraphQL error:", err);
    }
  }






async function explodeMetaObjects(handle,compareTo,source) {
  console.log(source,handle,compareTo)
  let tokenData = null;

try {
  tokenData = JSON.parse(localStorage.getItem("agchimpToken"));
} catch (e) {
  console.warn("Invalid agchimpToken");
}

  if(handle.length>0){
  var data = JSON.parse(handle);
  var data2=[];
 var settings = {
  "url": "https://agchimpapi.azurewebsites.net/api/Shopify/graph",
  "method": "POST",
  "timeout": 0,
  "headers": {
    "Content-Type": "application/json",
    "Authorization": "Bearer " + tokenData.token,
  },
  "data": JSON.stringify({
    query: "query ResolveMetaobjectHandles($ids: [ID!]!) {\r\n  nodes(ids: $ids) {\r\n    ... on Metaobject {\r\n      id\r\n      handle\r\n      type\r\n    }\r\n  }\r\n}",
    variables: {
      "ids": data
    }
  })
};

$.ajax(settings).done(function (response) {

  $.each(response.data.nodes,function(){
    data2.push({
    'handle':this.handle
    });
  });

  handle = data2;

const handleSet = new Set(
  handle.map(item => item.handle.toLowerCase())
);

const matched = compareTo.filter(obj =>
  handleSet.has(obj.handle.toLowerCase())
);
const matchedMetaobjects = compareTo.filter(item =>
  handleSet.has(item.handle.toLowerCase())
);
console.log(source)
if(source=='nutrients'){
buildNutrientCards(matchedMetaobjects,'lawn');
}
if(source=="cropNutrients"){
  buildNutrientCards(matchedMetaobjects,'crop');
  
}
if(source=='grasses'){
buildGrassTypeCards(matchedMetaobjects);
}
if(source=="crops"){
  console.log('building safe crops');
  buildGardenCropCards(matchedMetaobjects);
}
})
  }
}

function buildGrassTypeCards(data){

  if(data.length>0){
   
    $('#cropTypeButton').html('Safe For Use On')
    var card='';
    $('.cropTypes').removeClass('d-none');
    $.each(data,function(){
       var commonName='';
    var scientificName='';
    var imageMain='';
    var link=this.handle;
      $.each(this.fields,function(key,index){
        
        if(index.key=="common_name"){
          commonName = (this.value)
        }
        if(index.key=="scientific_name"){
          scientificName = (this.value)
        }
        if(index.key=="image"){
          imageMain = (this.reference.image.url)
        }
        if(index.key=="image"){
          imageMain = (this.reference.image.url)
        }
      })
 card += `<div class="agc-control-card"><div class="agc-control-image">
        <img src="`+imageMain+`" alt="" style="max-width:120px;">
      <div class="agc-control-common">${commonName || ""}</div>
      <div class="agc-control-scientific">${scientificName || ""}</div>
      <a href="`+link+`" class="agc-control-btn">Learn More</a></div></div>`;
})

$('#cropTypesList').html(card);
  }
}

function buildGardenCropCards(data){
console.log('building garden crops');
console.log(data)
  if(data.length>0){
   
    $('#cropTypeButton').html('Safe For Use On')
    var card='';
    $('.cropTypes').removeClass('d-none');
    $.each(data,function(){
       var commonName='';
    var scientificName='';
    var imageMain='';
    var link=this.handle;
      $.each(this.fields,function(key,index){
        
        if(index.key=="common_name"){
          commonName = (this.value)
        }
        if(index.key=="scientific_name"){
          scientificName = (this.value)
        }
        if(index.key=="image"){
          imageMain = (this.reference.image.url)
        }
        if(index.key=="image"){
          imageMain = (this.reference.image.url)
        }
      })
 card += `<div class="agc-control-card"><div class="agc-control-image">
        <img src="`+imageMain+`" alt="" style="max-width:120px;">
      <div class="agc-control-common">${commonName || ""}</div>
      <a href="`+link+`" class="agc-control-btn">Learn More</a></div></div>`;
})

$('#cropTypesList').html(card);
  }
}






function buildNutrientCards(data,target){

  
  var nutrientCards='';

$.each(data,function(){

  var sortOrder=0;
  var nutrientName='';
  var nutrientIcon='';
  var nutrientDescription='';
  $.each(this.fields,function(){
  if(this.key==="nutrient_name"){
      nutrientName = this.value;
   
  }
  if(this.key==="nutrient_icon"){
      nutrientIcon = this.reference.image.url;

  }
  if(this.key==="nurtient_description"){
      nutrientDescription = this.value;
  }
  if(this.key==="sort_order"){
      sortOrder = this.value;
  }
})
if(target=="crop"){
  nutrientCards +=`<div class="agc-nutrient-card">
  <div class="agc-nutrient-icon">
    <img src="`+nutrientIcon+`" style="height:60px;" alt="`+nutrientName+`">
  </div>

  <div class="agc-nutrient-content">
    <h5 class="agc-nutrient-title">`+nutrientName+`</h5>
    `+renderNutrientDescription(nutrientDescription)+`
  </div>
</div>`;
}
 else {
    nutrientCards +=`<div class="agc-nutrient-card">
  <div class="agc-nutrient-icon">
    <img src="`+nutrientIcon+`" style="height:60px;" alt="`+nutrientName+`">
  </div>

  <div class="agc-nutrient-content">
    <h5 class="agc-nutrient-title">`+nutrientName+`</h5>
    <p class="agc-nutrient-desc">`+nutrientDescription+`</p>
  </div>
</div>`;
 }
})
if(target=="lawn"){
  $('.agc-crop-nutrients-title').addClass('d-none');
  $('.agc-nutrients-title').removeClass('d-none');
$('#nutrientContainer').html(nutrientCards);
}
if(target=="crop"){
  $('.agc-nutrients-title').addClass('d-none');
    $('.agc-crop-nutrients-title').removeClass('d-none');
$('#cropnutrientContainer').html(nutrientCards);
}
}





//Handle Controlled Pests Tab

function renderControlsInTab(controls) {
 
  const container = document.getElementById("controlsList");
  if (!container) return;

  container.innerHTML = "";

  if (!controls.length) {
    container.innerHTML = "<p>No controlled items listed for this product.</p>";
    return;
  }
   var card='';
  controls.forEach(control => {

   var commonName='';
   var scientificName='';
   var imageMain='';
    var link=control.node.handle;
    $.each(control.node.fields,function(key,index){

      if(index.key==="common_name"){
        commonName = index.value;
        
      }
      if(index.key==="scientific_name"){
        scientificName = index.value;
      }
      if(index.key==="image_main"){
        imageMain = index.reference.image.url;
       
      }
    
        
  
      
      
    })
    
    card += `<div class="agc-control-card"><div class="agc-control-image">
        <img src="`+imageMain+`" alt="" style="max-width:120px;">
      <div class="agc-control-common">${commonName || ""}</div>
      <div class="agc-control-scientific">${scientificName || ""}</div>
      <a href="/pages/weed/${link || ""}" class="agc-control-btn">Learn More</a></div></div>`;

  });

  $('#controlsList').html(card);
}












// Handles all of the syncing and clicking for product variant buttons.
// -Brian Buchanana 12/22/2025

function fireVariantButtons(){
  const picker = document.querySelector(".js-variant-picker");
  const buttons = document.querySelectorAll(".variant-btn");
  console.log(buttons);
  if (!picker || !buttons.length || !agcProductData) return;

  let selectedOptions = [];

  function activateButton(button) {
    $('#min_purchase_qty').html($(button).data('stepqty'));
    $('#pack_qty').html($(button).data('packqty'));
    console.log(this)
      $('.variant-btn').removeClass('active');
    if (window.customerData?.tags?.includes('wholesale')) {
      $('.b2bRow').removeClass('d-none');
    } else {
      $('.b2bRow').addClass('d-none');
    }
    var stepQty = $(button).data('stepqty');
    console.log(stepQty)
    const optionIndex = Number(button.dataset.option);

    document
      .querySelectorAll(`.variant-btn[data-option="${optionIndex}"]`)
      .forEach(b => b.classList.remove("active"));

    button.classList.add("active");
    var stepQty = parseFloat($(button).data('stepqty'));
    $('.qty-input').val(stepQty);
  $('.qty-plus')
  .data('stepqty', stepQty)
  .attr('data-stepqty', stepQty);

$('.qty-minus')
  .data('stepqty', stepQty)
  .attr('data-stepqty', stepQty);
    selectedOptions[optionIndex] = button.dataset.value;
  }

  function syncVariant() {
 $.each($('.variant-btn'), function () {
  const btn = $(this);
  const btnValue = btn.data('value');

  let isWholesale = false;
  

  // 🔹 loop variants ONCE per button
    let min_purchase_qty = 1; // ✅ MUST be per-button
    let packQty=1;
  $.each(productVariants, function () {
  
    if (this.node.title === btnValue) {
      $.each(this.node.metafields.edges, function () {

        if (
          this.node.key === "iswholesale" &&
          this.node.value === "true"
        ) {
          isWholesale = true;
        }

        if (this.node.key === "min_purchase_qty") {
          min_purchase_qty = parseInt(this.node.value, 10) || 1;
        }
        if (this.node.key === "pack_qty") {
          packQty = parseInt(this.node.value, 10) || 1;
        }
      });

      // 🔒 break out once matched
      return false;
    }
  });

  // 🔹 apply class ONCE
  if (isWholesale) {
    btn.addClass('isWholesale').removeClass('isRetail');
    

  } else {
    btn.addClass('isRetail').removeClass('isWholesale');
  }

  // 🔹 APPLY STEP QTY TO BUTTON
  btn
    .data('stepqty', min_purchase_qty)
    .attr('data-stepqty', min_purchase_qty);
 btn
    .data('packqty', packQty)
    .attr('data-packqty', packQty);
  console.log(btnValue, isWholesale, min_purchase_qty);
});

// 🔹 wholesale auto-select logic (RUN ONCE, NOT PER BUTTON)
if (window.customerData?.tags?.includes('wholesale')) {
  $('.isRetail').addClass('d-none');
  if(isLoaded==false){
  $('.variant-btn').removeClass('active');
   $('.variant-btn:not(.d-none)').first().addClass('active').click();
  }
} else {
  $('.isRetail').removeClass('d-none');
  $('.isWholesale').addClass('d-none');
    if(isLoaded==false){
   $('.variant-btn:not(.d-none)').first().addClass('active').click();
    }
}
$('.variant-price').removeClass('d-none');
$('.variant-values').removeClass('d-none');

    const match = agcProductData.variants.find(v =>
      v.options.every((opt, i) => selectedOptions[i] === opt)
    );

    if (match) {
      console.log(match)
      $('#agc_variant_weight').html(((match.weight)/453.592).toFixed(2) + " lbs");
      $('#agc_variant_sku').html(match.sku);
      $('#agc_variant_upc').html(match.barcode);
      $('#variantPrice h4').html(accounting.formatMoney(match.price/100));
     
      
      picker.value = match.id;
      picker.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  // Click handling
  buttons.forEach(button => {
    button.addEventListener("click", () => {
      
      activateButton(button);
      syncVariant();
    });
  });

  // Default state
  console.log( agcProductData)
  agcProductData.options.forEach((_, optionIndex) => {
    const firstBtn = document.querySelector(
      `.variant-btn[data-option="${optionIndex}"]`
    );
    if (firstBtn) activateButton(firstBtn);
  });

   syncVariant();

document.querySelectorAll(".agc-qty").forEach(qty => {
  const input = qty.querySelector(".qty-input");
  const minusBtn = qty.querySelector(".qty-minus");
  const plusBtn = qty.querySelector(".qty-plus");

  function getStep() {
    return parseInt(minusBtn.dataset.stepqty, 10) || 1;
  }

  plusBtn.addEventListener("click", () => {
    const step = getStep();
    input.value = Number(input.value || step) + step;
  });

  minusBtn.addEventListener("click", () => {
    const step = getStep();
    const min = step; // enforce min qty = step
    input.value = Math.max(min, Number(input.value) - step);
  });
});

    const tabs = document.querySelectorAll(".agc-tab");
  const contents = document.querySelectorAll(".agc-tab-content");

  if (!tabs.length || !contents.length) return;

  tabs.forEach(tab => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tab;

      // deactivate all tabs
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      // activate selected
      tab.classList.add("active");
      const activeContent = document.getElementById(target);
      if (activeContent) {
        activeContent.classList.add("active");
      }
    });
  });
isLoaded=true;
}

function renderNutrientDescription(nutrientDescription) {
  if (!nutrientDescription || nutrientDescription.length <= 160) {
    return `<p class="agc-nutrient-desc">${nutrientDescription}</p>`;
  }

  const shortText = nutrientDescription.substring(0, 160).trim();

  return `
    <p class="agc-nutrient-desc">
      <span class="short-text">${shortText}...</span>
      <span class="full-text d-none">${nutrientDescription}</span>
      <a href="#" class="toggle-desc" data-state="collapsed">Read more</a>
    </p>
  `;
}

$(document).on('click', '.toggle-desc', function (e) {
  e.preventDefault();

  const $btn = $(this);
  const $p = $btn.closest('.agc-nutrient-desc');

  const isCollapsed = $btn.data('state') === 'collapsed';

  if (isCollapsed) {
    $p.find('.short-text').addClass('d-none');
    $p.find('.full-text').removeClass('d-none');
    $btn.text('Show less').data('state', 'expanded');
  } else {
    $p.find('.full-text').addClass('d-none');
    $p.find('.short-text').removeClass('d-none');
    $btn.text('Read more').data('state', 'collapsed');
  }
});


function getComplementaryProductId(graphQLResponse) {

  const metafields = graphQLResponse?.data?.product?.metafields?.edges;
  if (!metafields) return null;

  const complementaryMeta = metafields.find(
    m =>
      m.node.namespace === "custom" &&
      m.node.key === "complementary_product"
  );

  return complementaryMeta?.node?.value || null;
}

async function loadComplementaryProduct(productJson) {
console.log(productJson);
  const complementaryProductGid = getComplementaryProductId(productJson);
  if (!complementaryProductGid) return;

  const tokenData = JSON.parse(localStorage['agchimpToken']);

  const response = await $.ajax({
    url: "https://agchimpapi.azurewebsites.net/api/Shopify/graph",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer " + tokenData.token
    },
    data: JSON.stringify({
      query: `
        query ($id: ID!) {
  product(id: $id) {
    title
    description
    featuredImage {
      url
    }
    variants(first: 25) {
      edges {
        node {
          id
          title
          price
          availableForSale
            metafield(namespace: "custom", key: "isWholesale") {
            value
          }
        }
      }
    }
  }
}
      `,
      variables: { id: complementaryProductGid }
    })
  });

  const product = response.data.product;
  if (!product) return;

  // Populate UI
  $("#agc-comp-title").text(`${product.title}`);
  $("#agc-comp-description").html(product.description);
  $("#agc-comp-image").attr("src", product.featuredImage?.url || "");

  const variants = product.variants.edges;
  console.log(variants)
  if (variants.length > 1) {
    console.log('has1')
    $('#agc-complementary-product').removeClass('d-none');
   
    var agcCompVariant='';
    var compKey =-1;
    variants.forEach(v => {
      compKey+=compKey+1;
  const isWholesale =
    v.node.metafield?.value === "true";

  // hide wholesale-only variants from retail users
  if (
    isWholesale &&
    !window.customerData?.tags?.includes("wholesale")
  ) {
    return;
  } else {
  agcCompVariant +=`<button type="button" data-price="${v.node.price}" data-iswholesale="${isWholesale}" class="agc-comp-size-btn" data-option="${compKey}" data-value="${v.node.id}" data-stepqty="1" data-packqty="1">
        `+v.node.title+`
      </button>`
  
  }
});

$('.agc-comp-sizes').html(agcCompVariant);
selectFirstComplementarySize();
}
}




function selectFirstComplementarySize() {
  const container = document.querySelector(".agc-comp-sizes");
  if (!container) return;

  const buttons = container.querySelectorAll(".agc-comp-size-btn");
  if (!buttons.length) return;

  // remove any existing active states
  buttons.forEach(btn => btn.classList.remove("active"));

  // activate first
  const firstBtn = buttons[0];
  firstBtn.classList.add("active");

  // OPTIONAL: sync price + variant id
  const price = firstBtn.dataset.price;
  const variantId = firstBtn.dataset.value;

  if (price) {
    document.getElementById("agc-comp-price").textContent =
      accounting.formatMoney(price);
  }

  if (variantId) {
    document
      .getElementById("agc-comp-add")
      .setAttribute("data-variant-id", variantId);
  }
}

document.addEventListener("click", function (e) {
  const btn = e.target.closest(".agc-comp-size-btn");
  if (!btn) return;

  const container = btn.closest(".agc-comp-sizes");
  if (!container) return;

  container
    .querySelectorAll(".agc-comp-size-btn")
    .forEach(b => b.classList.remove("active"));

  btn.classList.add("active");

  // sync price
  if (btn.dataset.price) {
    document.getElementById("agc-comp-price").textContent =
      accounting.formatMoney(btn.dataset.price / 100);
  }

  // sync variant
  document
    .getElementById("agc-comp-add")
    .setAttribute("data-variant-id", btn.dataset.variantId);
});


$(document).on("click", "#agc-comp-add", function (e) {
  e.preventDefault();
  comp = $(this).data('variant-id');
  compVariant = parseInt(comp.replace('gid://shopify/ProductVariant/',''));
  qty= parseInt($('#agc-comp-qty').val());
  $.ajax({
    url: "/cart/add.js",
    method: "POST",
    dataType: "json",        // ✅ THIS FIXES THE ERROR
    data: {
      items: [{
        id: compVariant,
        quantity: qty
      }]
    },
    success: function (res) {
      console.log("Added:", res);
      var previousQty= parseInt($('.header__cart-count-number').html())
      $('.header__cart-count-number').html(parseInt(previousQty + qty));
      console.log(parseInt(previousQty + qty))
    },
    error: function (xhr) {
      console.error("Add failed:", xhr.responseText);
    }
  });
});
document.addEventListener("DOMContentLoaded", function () {
  getProduct();
});
$('#mapAgreementCheckbox').on('change', function () {
  
  if ($(this).prop('checked')) {
    setIsMapAcknowledged(customerData.id,"true");
    $('.agc-map-acknowledgement').addClass('d-none');
  } else {
    setIsMapAcknowledged(customerData.id,"false");
  }
});
}


async function setIsMapAcknowledged(custId,value) {
  var data = {
  "input": {
    "id": "gid://shopify/Customer/" + custId,
    "metafields": [
      {
        "namespace": "custom",
        "key": "ismapacknowledged",
        "type": "boolean",
        "value": value
      }
    ]
  }
}
console.log(data)
  try {
    const response = await graphQuery(updateIsMapAcknowledged, data);
    console.log(response);
     window.open(
      'https://na2.docusign.net/Member/PowerFormSigning.aspx?PowerFormId=d448854a-c1aa-4faf-890e-a81aae096c55&env=na2&acct=efc711d8-a508-4149-9809-b2f938d6da12&v=2',
      '_blank',
      'noopener,noreferrer'
    );
   
  } catch (err) {
    console.error("GraphQL error:", err);
    throw err;
  }
}
